import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Grid } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import UserDetail from './UserDetail';
import TripDetails from './TripDetails';
import ActionBlock from './ActionBlock';
import SendMessage from './SendMessage';
import ThreadItems from './ThreadItems';
import Loader from '../Loader';
import { withQuery } from '../../hoc/withGraphql';

import GetThreadQuery from './GetThreadQuery.graphql';
import GetMoreThreadItemsQuery from './GetMoreThreadItemsQuery.graphql';
import messages from '../../locale/messages';

import s from './ViewMessage.css';

const ViewMessage = ({ threadId, userType, threadData }) => {
  const [location, setLocation] = useState('');
  const { getThread, loading, fetchMore } = threadData || {};

  const { isAdminAuthenticated, toCurrency } = useSelector((state) => ({
    isAdminAuthenticated: state?.runtime?.isAdminAuthenticated,
    toCurrency: state.currency.to || state.currency.base,
  }));

  useEffect(() => {
    if (history.location) {
      setLocation(history.location.pathname);
    }
  }, []);


  const loadMore = () => {
    const { threadItems } = getThread || {};
    fetchMore({
      query: GetMoreThreadItemsQuery,
      variables: {
        threadId,
        offset: threadItems.length,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }
        return {
          getThread: {
            ...previousResult.getThread,
            threadItems: [
              ...previousResult.getThread.threadItems,
              ...fetchMoreResult.getAllThreadItems,
            ],
          },
        };
      },
    });
  };

  if (loading) {
    return <Loader type={'text'} />;
  }

  if (getThread?.threadItemForType && getThread?.hostProfile && getThread?.guestProfile) {
    let receiverName = getThread?.guestProfile?.firstName;
    let hostUserBanStatus = getThread?.hostUserData?.userBanStatus;
    let guestUserBanStatus = getThread?.guestUserData?.userBanStatus;
    let senderName = getThread?.hostProfile?.firstName;
    let receiverType = 'guest';
    let receiverEmail = getThread?.guestUserData?.email;
    let isListAvailable = false;
    let listPublishStatus;

    let profileId, picture, displayName, firstName, reviewsCount, verifications;
    if (userType === 'guest') {
      profileId = getThread?.hostProfile?.profileId;
      picture = getThread?.hostProfile?.picture;
      displayName = getThread?.hostProfile?.firstName;
      firstName = getThread?.hostProfile?.firstName;
      reviewsCount = getThread?.hostProfile?.reviewsCount;
      verifications = getThread?.hostProfile?.userVerification;
      receiverName = getThread?.hostProfile?.firstName;
      senderName = getThread?.guestProfile?.firstName;
      receiverType = 'host';
      receiverEmail = getThread?.hostUserData?.email;
    } else {
      profileId = getThread?.guestProfile?.profileId;
      picture = getThread?.guestProfile?.picture;
      displayName = getThread?.guestProfile?.firstName;
      firstName = getThread?.guestProfile?.firstName;
      reviewsCount = getThread?.guestProfile?.reviewsCount;
      verifications = getThread?.guestProfile?.userVerification;
    }

    const initialValues = {
      threadId,
      threadType: userType,
      type: 'message',
      receiverName,
      senderName,
      receiverType,
      receiverEmail,
    };

    if (getThread?.listData) {
      isListAvailable = true;
      listPublishStatus = getThread?.listData?.isPublished;
    }

    return (
      <div>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12} className={cx(s.space4, s.paddingNone, 'visible-xs')}>
            {!guestUserBanStatus && !hostUserBanStatus && (
              <ActionBlock
                threadType={userType}
                actionType={getThread?.threadItemForType?.type}
                threadId={threadId}
                listId={getThread?.listId}
                reservationId={getThread?.threadItemForType?.reservationId}
                startDate={getThread?.threadItemForType?.startDate}
                endDate={getThread?.threadItemForType?.endDate}
                personCapacity={getThread?.threadItemForType?.personCapacity}
                createdAt={getThread?.threadItemForType?.createdAt}
                hostDisplayName={getThread?.hostProfile?.firstName}
                guestDisplayName={getThread?.guestProfile?.firstName}
                guestEmail={getThread?.guestUserData?.email}
                title={getThread?.listData?.title}
                listPublishStatus={listPublishStatus}
                reservationData={getThread?.threadItemForType?.reservation || {}}
                country={getThread?.listData?.country}
              />
            )}
          </Col>
          <Col lg={7} md={7} sm={6} xs={12} className={cx(s.space4, s.messageBoxBg, s.paddingNone)}>
            {!isAdminAuthenticated && (
              <SendMessage
                initialValues={initialValues}
                threadId={threadId}
                profileId={userType === 'host' ? getThread?.hostProfile?.profileId : getThread?.guestProfile?.profileId}
                picture={userType === 'host' ? getThread?.hostProfile?.picture : getThread?.guestProfile?.picture}
                displayName={userType === 'host' ? getThread?.hostProfile?.firstName : getThread?.guestProfile?.firstName}
              />
            )}
            <UserDetail
              profileId={profileId}
              picture={picture}
              displayName={displayName}
              userName={firstName}
              hostProfileId={profileId}
              location={userType === 'host' ? getThread?.guestProfile?.location : getThread?.hostProfile?.location}
              reviewsCount={reviewsCount}
              verifications={verifications}
              userType={userType}
            />
            <ThreadItems userType={userType} threadId={threadId} data={getThread} loadMore={loadMore} />
          </Col>
          <Col lg={5} md={5} sm={6} xs={12} className={cx(s.space4, 'hidden-xs', 'paddingRightAR')}>
            {!guestUserBanStatus && !hostUserBanStatus && (
              <ActionBlock
                threadType={userType}
                actionType={getThread?.threadItemForType?.type}
                threadId={threadId}
                listId={getThread?.listId}
                reservationId={getThread?.threadItemForType?.reservationId}
                startDate={getThread?.threadItemForType?.startDate}
                endDate={getThread?.threadItemForType?.endDate}
                personCapacity={getThread?.threadItemForType?.personCapacity}
                createdAt={getThread?.threadItemForType?.createdAt}
                hostDisplayName={getThread?.hostProfile?.firstName}
                guestDisplayName={isAdminAuthenticated ? getThread?.guestProfile?.displayName : getThread?.guestProfile?.firstName}
                guestEmail={getThread?.guestUserData?.email}
                title={getThread?.listData?.title}
                listPublishStatus={listPublishStatus}
                reservationData={getThread?.threadItemForType?.reservation || {}}
                country={getThread?.listData?.country}
              />
            )}

            {isListAvailable && (
              <TripDetails
                threadId={threadId}
                toCurrency={toCurrency}
                listId={getThread?.listId}
                userType={userType}
                title={getThread?.threadItemForType?.reservation?.listTitle || getThread?.listData?.title}
                basePrice={getThread?.listData?.listingData?.basePrice}
                cleaningPrice={getThread?.listData?.listingData?.cleaningPrice}
                monthlyDiscount={getThread?.listData?.listingData?.monthlyDiscount}
                weeklyDiscount={getThread?.listData?.listingData?.weeklyDiscount}
                currency={getThread?.listData?.listingData?.currency}
                startDate={getThread?.threadItemForType?.startDate}
                endDate={getThread?.threadItemForType?.endDate}
                personCapacity={getThread?.threadItemForType?.personCapacity}
                cancelData={getThread?.threadItemForType?.cancelData}
                reservationData={getThread?.threadItemForType?.reservation || undefined}
              />
            )}

            {!isListAvailable && <FormattedMessage {...messages.noList} />}
          </Col>

          <Col lg={4} md={4} sm={4} xs={12} className={cx(s.sidebarDesign, s.space4, 'visible-xs')}>
            {isListAvailable && (
              <TripDetails
                threadId={threadId}
                toCurrency={toCurrency}
                listId={getThread?.listId}
                userType={userType}
                title={getThread?.threadItemForType?.reservation?.listTitle || getThread?.listData?.title}
                basePrice={getThread?.listData?.listingData?.basePrice}
                cleaningPrice={getThread?.listData?.listingData?.cleaningPrice}
                monthlyDiscount={getThread?.listData?.listingData?.monthlyDiscount}
                weeklyDiscount={getThread?.listData?.listingData?.weeklyDiscount}
                currency={getThread?.listData?.listingData?.currency}
                startDate={getThread?.threadItemForType?.startDate}
                endDate={getThread?.threadItemForType?.endDate}
                personCapacity={getThread?.threadItemForType?.personCapacity}
                cancelData={getThread?.threadItemForType?.cancelData}
                reservationData={getThread?.threadItemForType?.reservation || undefined}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <Grid>
      <Row>
        <Col className={cx(s.space4, 'textCenterAdmin')}>
          <FormattedMessage {...messages.noThreadFound} />
        </Col>
      </Row>
    </Grid>
  );
};

export default withStyles(s)(
  withQuery(GetThreadQuery, {
    name: 'threadData',
    options: (props) => ({
      variables: {
        threadId: props.threadId,
        threadType: props.userType,
      },
      ssr: false,
      fetchPolicy: 'network-only',
    }),
  })(ViewMessage)
);